import gql from 'graphql-tag'

export const mutation = gql`
  mutation deleteInspectionComponent($id: Int!) {
    record: delete_purchase_inspection_component_by_pk(id: $id) {
      id
    }
  }
`

export default mutation
